import { N800 } from '@atlaskit/theme/colors';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { messages } from '../messages';
import { isNotEmpty } from '../utils/filters';
import {
  default as ProductDropdownItemWithAnalytics,
  ProductDropdownItemProps
} from './product-dropdown-item';

import { UserProfileViewType } from '../user-profile-view';

export type ProductsViewProps = {
  readonly products: ProductDropdownItemProps[];
  readonly type?: UserProfileViewType;
  readonly domRootId?: string;
};

export function ProductsView({ products, type, domRootId }: ProductsViewProps) {
  return (
    <Container>
      <MessageLabel>
        {type === 'wac-mobile' ? (
          <div>
            <FormattedMessage {...messages.cloudProductsMobile} />
            <MessageLabelDivider />
          </div>
        ) : (
          <FormattedMessage {...messages.cloudProducts} />
        )}
      </MessageLabel>
      {products
        .filter(({ sites }) => isNotEmpty(sites))
        .map((product) => (
          <ProductDropdownItemWithAnalytics
            domRootId={domRootId}
            key={product.name}
            {...product}
          />
        ))}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin: 12px 0;
`;

const MessageLabel = styled.span`
  margin-left: 12px;
  margin-bottom: 11px;
  font-size: 12px;
  line-height: 14px;
  color: ${N800};
`;

const MessageLabelDivider = styled.hr`
  width: 64px;
  margin-left: 0px;
`;
